import type { ElementType } from 'react'
import { type Signal, attachDriver } from '@rwwa/rwwa-rx-state-machine'
import { type TypedRecord, makeTypedFactory } from 'typed-immutable-record'
import { layering } from '@mobi/component-library/Foundations'
import type { OverlayOpenProps } from '@core/Components/Overlay/types'
import { OverlayClose, OverlayOpen, OverlayReset } from './signals'

export interface OverlayState {
  Component: ElementType | null
  layer: typeof layering.overlayLow | typeof layering.overlayHigh | typeof layering.modalOverlayHigh
  isOpen: boolean
}
export const defaultState: OverlayState = {
  Component: null,
  layer: layering.overlayLow,
  isOpen: false,
}

export interface OverlayStateRecord extends TypedRecord<OverlayStateRecord>, OverlayState {}
const OverlayStateFactory = makeTypedFactory<OverlayState, OverlayStateRecord>(defaultState)

export const driver = (state = OverlayStateFactory(), signal: Signal) => {
  switch (signal.tag) {
    case OverlayOpen: {
      const data: OverlayOpenProps | null = signal.data

      if (data !== null && typeof data !== 'string' && 'layer' in data) {
        return state.merge({
          Component: data.Component,
          layer: data.layer,
          isOpen: true,
        })
      }

      return state.merge({
        Component: data,
        layer: layering.overlayLow,
        isOpen: true,
      })
    }

    case OverlayClose: {
      return state.merge({
        isOpen: false,
      })
    }

    case OverlayReset: {
      return state.merge({
        ...defaultState,
      })
    }

    default:
      return state
  }
}

export const state$ = attachDriver({ driver, path: `Overlay-React` })
